import { render, staticRenderFns } from "./FiltrosDeListagemArticuladorRegional.vue?vue&type=template&id=567b5786"
import script from "./FiltrosDeListagemArticuladorRegional.vue?vue&type=script&lang=js"
export * from "./FiltrosDeListagemArticuladorRegional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports